import React from 'react'

const Placeholder = () => (
  <div className='col py-1 mr-auto'>
    <div className='row align-items-center h-100 '>
      <div className='col-2 py-half txt-body-sm bg-ui-3 radius' />
    </div>
  </div>
)
export default Placeholder



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/Title/Placeholder.js